import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "icon"]
  static values = {
    text: String,
    successMessage: { type: String, default: "Copiado com sucesso!" }
  }

  notificationsController = null

  copy() {
    let textToCopy = ""

    // If there's a source target, copy its text content
    if (this.hasSourceTarget) {
      textToCopy = this.sourceTarget.innerText || this.sourceTarget.textContent
    } else if (this.hasTextValue) {
      textToCopy = this.textValue
    }

    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.showCopiedFeedback()
        const notificationsController = this.getNotificationsController()
        if (notificationsController) {
          notificationsController.showNotification(this.successMessageValue, 'success')
        }
      })
    }
  }

  // Legacy method for backwards compatibility
  copyText() {
    navigator.clipboard.writeText(this.textValue)
    const notificationsController = this.getNotificationsController()
    if (notificationsController) {
      notificationsController.showNotification("Link copiado com sucesso!", 'success')
    }
  }

  showCopiedFeedback() {
    if (!this.hasIconTarget) return

    // Store original icon
    const originalHTML = this.iconTarget.innerHTML

    // Show checkmark
    this.iconTarget.innerHTML = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />`
    this.iconTarget.classList.add('text-green-500')

    // Restore after 2 seconds
    setTimeout(() => {
      this.iconTarget.innerHTML = originalHTML
      this.iconTarget.classList.remove('text-green-500')
    }, 2000)
  }

  getNotificationsController() {
    if (!this.notificationsController) {
      const element = document.querySelector('[data-controller*="notifications"]')
      if (element) {
        this.notificationsController = this.application.getControllerForElementAndIdentifier(
          element,
          "notifications"
        )
      }
    }
    return this.notificationsController
  }
}
